import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Popover as MuiPopover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import makeClass from 'classnames';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      marginTop: theme.spacing(1)
    },
    paper: {
      padding: theme.spacing(2)
    }
  };
});

var Popover = function Popover(_ref) {
  var a11yId = _ref.a11yId,
      children = _ref.children,
      className = _ref.className,
      disableRestoreFocus = _ref.disableRestoreFocus,
      dsOnClose = _ref.dsOnClose,
      e2e = _ref.e2e,
      body = _ref.body,
      _ref$anchorEl = _ref.anchorEl,
      anchorEl = _ref$anchorEl === void 0 ? null : _ref$anchorEl,
      getBodySlot = _ref.getBodySlot,
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _ref$anchorOrigin,
      _ref$transformOrigin = _ref.transformOrigin,
      transformOrigin = _ref$transformOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'center'
  } : _ref$transformOrigin,
      open = _ref.open;
  var classes = useStyles();
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);

  if (!anchorEl) {
    return null;
  }

  return /*#__PURE__*/React.createElement(MuiPopover, _extends({
    className: makeClass(classes.root, className),
    classes: classes,
    disableRestoreFocus: disableRestoreFocus
  }, e2e && {
    'data-e2e': e2e
  }, {
    id: a11yId,
    open: open,
    onClose: dsOnClose,
    anchorEl: anchorEl,
    transformOrigin: transformOrigin,
    anchorOrigin: anchorOrigin
  }), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.paper,
    ref: bodyCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body, " ", children));
};

export default Popover;

try {
  Popover.__docgenInfo = {
    description: '',
    displayName: 'Popover',
    methods: [],
    props: {
      a11yId: {
        defaultValue: null,
        description: '',
        name: 'a11yId',
        required: true,
        type: {
          name: 'string'
        }
      },
      dsOnClose: {
        defaultValue: null,
        description: '',
        name: 'dsOnClose',
        required: false,
        type: {
          name: '(event: {}, reason: "backdropClick" | "escapeKeyDown") => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      classes: {
        defaultValue: null,
        description: 'Override or extend the styles applied to the component.',
        name: 'classes',
        required: false,
        type: {
          name: 'Partial<ClassNameMap<PopoverClassKey>>'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        required: false,
        type: {
          name: 'string'
        }
      },
      open: {
        defaultValue: null,
        description: 'If `true`, the popover is visible.',
        name: 'open',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      anchorEl: {
        defaultValue: {
          value: null
        },
        description: 'A HTML element, or a function that returns it.\n' + "It's used to set the position of the popover.",
        name: 'anchorEl',
        required: false,
        type: {
          name: 'Element | ((element: Element) => Element)'
        }
      },
      disableRestoreFocus: {
        defaultValue: null,
        description: '',
        name: 'disableRestoreFocus',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      anchorOrigin: {
        defaultValue: {
          value: "{\n    vertical: 'bottom',\n    horizontal: 'center',\n  }"
        },
        description: "This is the point on the anchor where the popover's\n" + '`anchorEl` will attach to. This is not used when the\n' + "anchorReference is 'anchorPosition'.\n" + '\n' + 'Options:\n' + 'vertical: [top, center, bottom];\n' + 'horizontal: [left, center, right].',
        name: 'anchorOrigin',
        required: false,
        type: {
          name: 'PopoverOrigin'
        }
      },
      transformOrigin: {
        defaultValue: {
          value: "{\n    vertical: 'top',\n    horizontal: 'center',\n  }"
        },
        description: 'This is the point on the popover which\n' + "will attach to the anchor's origin.\n" + '\n' + 'Options:\n' + 'vertical: [top, center, bottom, x(px)];\n' + 'horizontal: [left, center, right, x(px)].',
        name: 'transformOrigin',
        required: false,
        type: {
          name: 'PopoverOrigin'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map